// Grenser som håndheves både i klient (umiddelbar tilbakemelding)
// og på server (autoritativ validering).
export const TITLE_MAX = 150;
export const OPTION_MAX = 100;
export const OPTIONS_MIN = 2;
export const OPTIONS_MAX = 30;
export const DOTS_MIN = 1;
export const DOTS_MAX = 20;
